// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ebYh","delete":"styles_delete__1TmRt","update":"styles_update__2kL4F","add":"styles_add__7FnRN"};